export default __webpack_public_path__ + "static/media/setup-account-image.2502d34c.jpg";